module.exports = __webpack_public_path__ + "img/proship-logo-icon.f36c85a9.png";